import { useState, useEffect } from "react";
import "./EventNavBar.scss";
import { ViewPicker } from "./ViewPicker";

function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

export const EventNavBarList = (props) => {

  const [filterOptionsOne, setFilterOptionsOne] = useState(['Filter Program']);
  const [filterOptionsTwo, setFilterOptionsTwo] = useState(['Filter Instrument']);
  const [view, setView] = useState("List");

  useEffect(() => {
    // Fetch filter options from your data source
    fetchFilterOptionsOne();
    fetchFilterOptionsTwo();
  }, []);

  const fetchFilterOptionsOne = () => {
    // Make an API call to fetch events data
    fetch(`https://events.jazzforumarts.org/jazzforumarts/api/v3/events`)
      .then(response => response.json())
      .then(data => {
        // Extract unique event categories from the events data
        let categories = [...new Set(data.map(event => event.attribute_EventCategory))];
        // Sort categories
        categories = categories.sort((a, b) => a.toLowerCase().localeCompare(b.toLowerCase()));
        // Add "Filter Program" option at the beginning
        categories.unshift("Filter Program");
        // Set filter options for the first filter
        setFilterOptionsOne(categories);
      })
      .catch(error => {
        console.error('Error fetching event categories:', error);
      });
  };
  
  const fetchFilterOptionsTwo = () => {
    // Make an API call to fetch events data
    fetch(`https://events.jazzforumarts.org/jazzforumarts/api/v3/events`)
      .then(response => response.json())
      .then(data => {
        // Extract unique event categories from the events data
        let tags = [...new Set(data.map(event => event.attribute_EventTag2))];
        // Sort tags
        tags = tags.sort((a, b) => a.toLowerCase().localeCompare(b.toLowerCase()));
        // Add "Filter Instrument" option at the beginning
        tags.unshift("Filter Instrument");
        // Set filter options for the first filter
        setFilterOptionsTwo(tags);
      })
      .catch(error => {
        console.error('Error fetching event categories:', error);
      });
  };

  // Rest of component code...

  function onFilterValueChanged(event) {
    props.filterValueSelected(event.target.value);
  }

  function onFilterValueTwoChanged(eventTwo) {
    props.filterValueTwoSelected(eventTwo.target.value);
  }

  const onViewValueChanged = (viewValue) => {
    setView(viewValue);
    props.viewValueSelected(viewValue); // Pass the selected view value to the parent component
  };

  function onClearFilters() {
    if (props.filterTextValue === "Filter Program" && props.filterTextValueTwo === "Filter Instrument") {
      // Do nothing if both filters are already set to their default values
      return;
    } else {
      // Update the selected filter values in the parent component
      props.filterValueSelected("Filter Program");
      props.filterValueTwoSelected("Filter Instrument");
      // Refetch filter options to reset the filters
      setFilterOptionsOne(["Filter Program"]);
      setFilterOptionsTwo(["Filter Instrument"]);
      // Refetch filter options to reset the filters
      fetchFilterOptionsOne();
      fetchFilterOptionsTwo();
    }
  }

  const showFilterSection = props.viewValue !== "List";
  //console.log(windowView);

  //console.log('Sorted filterOptionsOne:', filterOptionsOne);
  //console.log('Sorted filterOptionsTwo:', filterOptionsTwo);

  return (
    <>
      <div className="flex  md:flex-row flex-auto flex-col">
        <div className="h-full md:hidden pb-2 sm:pb-4">
          <section className="">
            <div className="">
              <ViewPicker onViewValueChanged={onViewValueChanged} viewValue={view} />
            </div>
          </section>
        </div>

        <div className="flex-grow mb-3 md:mb-0 md:mr-4">
          <div className="">
            {showFilterSection && (
              <div className="">
                <div className="flex flex-col md:flex-row md:gap-2 content-stretch" style={{
                  fontFamily: "Montserrat, Poppins, sans-serif",
                  textTransform: "uppercase",
                  fontStyle: "italic",
                  flex: "1", // Take up remaining space
                }}>
                  <div className="justify-items-center" id="cFilter">
                    {filterOptionsOne.length > 0 && ( // Check if options array is not empty
                      <select
                        name="Filter Program"
                        className="font-medium text-base text-white py-3 px-3 border uppercase"
                        onChange={onFilterValueChanged} style={{
                          minWidth: "275px",
                          minHeight: "46px",
                          background: "#2D2D2D",
                          fontFamily: "Montserrat, Poppins, sans-serif",
                          textTransform: "uppercase",
                          fontStyle: "italic",
                          // Hide the default dropdown arrow
                          appearance: "none",
                          // Adjust the appearance of the custom dropdown arrow
                          backgroundImage: `url('data:image/svg+xml,%3Csvg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2.5" stroke="white" class="w-6 h-6"%3E%3Cpath stroke-linecap="round" stroke-linejoin="round" d="m19.5 8.25-7.5 7.5-7.5-7.5" /%3E%3C/svg%3E')`,
                          backgroundRepeat: "no-repeat",
                          backgroundPositionX: "calc(100% - 12px)",
                          backgroundPositionY: "center",
                          paddingRight: "24px", // Adjust this value to change the size of the arrow
                          backgroundSize: "20px", // Adjust this value to change the size of the arrow
                        }}
                      >
                        {filterOptionsOne.map((option) => option !== "" && (
                          <option key={option} value={option} style={{
                            background: "#2D2D2D",
                            fontFamily: "Montserrat, Poppins, sans-serif",
                            textTransform: "uppercase",
                            fontStyle: "italic",
                          }}>
                            {option}
                          </option>
                        ))}
                      </select>
                    )}
                  </div>
                  <div className="justify-items-center md:gap-2 md:px-4 hidden sm:flex" id="cFilter">
                    {filterOptionsTwo.length > 0 && ( // Check if options array is not empty
                      <select
                        name="Filter Instrument"
                        class="font-medium text-base text-white py-3 px-3 border uppercase"
                        onChange={onFilterValueTwoChanged}
                        style={{
                          minWidth: "275px",
                          minHeight: "46px",
                          background: "#2D2D2D",
                          fontFamily: "Montserrat, Poppins, sans-serif",
                          textTransform: "uppercase",
                          fontStyle: "italic",
                          // Hide the default dropdown arrow
                          appearance: "none",
                          // Adjust the appearance of the custom dropdown arrow
                          backgroundImage: `url('data:image/svg+xml,%3Csvg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2.5" stroke="white" class="w-6 h-6"%3E%3Cpath stroke-linecap="round" stroke-linejoin="round" d="m19.5 8.25-7.5 7.5-7.5-7.5" /%3E%3C/svg%3E')`,
                          backgroundRepeat: "no-repeat",
                          backgroundPositionX: "calc(100% - 12px)",
                          backgroundPositionY: "center",
                          paddingRight: "24px", // Adjust this value to change the size of the arrow
                          backgroundSize: "20px", // Adjust this value to change the size of the arrow
                        }}
                      >
                        {filterOptionsTwo.map((option) => option !== "" && (
                          <option key={option} value={option} style={{
                            background: "#2D2D2D",
                            fontFamily: "Montserrat, Poppins, sans-serif",
                            textTransform: "uppercase",
                            fontStyle: "italic",
                          }}>
                            {option}
                          </option>
                        ))}
                      </select>
                    )}
                  </div>
                </div>
                {/* Rest of your component code... */}
                <div className="flex flex-auto flex-col">
                  <header className="">
                    <nav
                      className="flex items-center justify-between pt-2"
                      aria-label="Global"
                    ></nav>
                    <div class="flex font-bold flex-col sm:flex-row" id="">
                      <div className="filter-info hidden">
                        {/* Conditionally render YOU ARE CURRENTLY VIEWING */}
                        {props.filterTextValue !== "Filter Program" ||
                          props.filterTextValueTwo !== "Filter Instrument" ? (
                          <div className="flex flex-auto flex-col">
                            <p className="text-xs sm:text-ms" style={{
                              fontFamily: "Montserrat, Poppins, sans-serif",
                              textTransform: "uppercase",
                              fontWeight: "100",
                              whiteSpace: "nowrap", // Prevent line breaks
                              //overflow: "hidden", // Hide overflowing text
                              //textOverflow: "ellipsis", // Display an ellipsis (...) to indicate text overflow
                              //flexGrow: 1,
                            }}>You are Currenly viewing:</p>
                            {props.filterTextValue !== "Filter Program" && (
                              <p className="text-white font-bold uppercase" id="cFilter" style={{
                                fontFamily: "Montserrat, Poppins, sans-serif",
                                textTransform: "uppercase",
                                fontWeight: "800",
                              }}>{props.filterTextValue}</p>
                            )}
                            {props.filterTextValueTwo !==
                              "Filter Instrument" && (
                                <p className="text-white font-bold uppercase" id="" style={{
                                  fontFamily: "Montserrat, Poppins, sans-serif",
                                  textTransform: "uppercase",
                                  fontWeight: "800",
                                }}>{props.filterTextValueTwo}</p>
                              )}
                          </div>
                        ) : (
                          <div className=""><p className="text-xs sm:text-ms" style={{
                            fontFamily: "Montserrat, Poppins, sans-serif",
                            textTransform: "uppercase",
                            fontWeight: "100",
                            whiteSpace: "nowrap", // Prevent line breaks
                            whiteSpace: "nowrap", // Prevent line breaks
                            //overflow: "hidden", // Hide overflowing text
                            //textOverflow: "ellipsis", // Display an ellipsis (...) to indicate text overflow
                            //flexGrow: 1,
                          }}>You are Currently viewing:</p> <p className="" style={{
                            fontFamily: "Montserrat, Poppins, sans-serif",
                            textTransform: "uppercase",
                            fontWeight: "800",
                          }}>All Events</p></div>
                        )}
                      </div>
                      <div style={{
                        fontFamily: "Montserrat, Poppins, sans-serif",
                        textTransform: "uppercase",
                        fontWeight: "bold",
                        fontSize: "14px",
                        marginTop: "12px",
                      }}>
                        <button
                          onClick={onClearFilters}
                          className="text-sm rounded-none pt-2" style={{
                            color: props.filterTextValue !== "Filter Program" || props.filterTextValueTwo !== "Filter Instrument" ? '#009ED0' : 'white',
                            transition: 'color 0.3s'
                          }}
                          onContextMenu={(e) => e.preventDefault()} // Disable right-click
                          onMouseEnter={(e) => e.target.style.color = props.filterTextValue !== "Filter Program" || props.filterTextValueTwo !== "Filter Instrument" ? 'white' : '#009ED0'}
                          onMouseLeave={(e) => e.target.style.color = props.filterTextValue !== "Filter Program" || props.filterTextValueTwo !== "Filter Instrument" ? '#009ED0' : 'white'}
                          onFocus={(e) => e.target.style.color = props.filterTextValue !== "Filter Program" || props.filterTextValueTwo !== "Filter Instrument" ? '#009ED0' : 'white'}
                          onBlur={(e) => e.target.style.color = props.filterTextValue !== "Filter Program" || props.filterTextValueTwo !== "Filter Instrument" ? '#009ED0' : 'white'}
                        >
                          CLEAR FILTER
                        </button>
                      </div>
                    </div>
                  </header>
                </div>
              </div>
            )}
          </div>
        </div>
        <div className="h-full mx-1 my-1.5 hidden md:flex">
          <ViewPicker onViewValueChanged={onViewValueChanged} viewValue={view} />
        </div>
      </div>
    </>
  );
};
